import { COLORS } from '@/config/colors';
import { css, fillOutlined, circle, roundedPoly, shade } from './draw-utils';
import type { ProceduralDef } from '../types';

const SCALE_DARK = 0x2c2340; // void-purple scales (Elementals: void flavor)
const RING = 0x9b59d0;

/**
 * B4 Twin Serpents parts — docs/02-bosses.md.
 * Head (frame 0 normal / 1 enraged) + body segment bead. Nose points +X.
 */
export const bossSerpentHead: ProceduralDef = {
  key: 'boss/serpent/head',
  width: 80,
  height: 80,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 2,
  draw(ctx, w, h, frame) {
    const c = w / 2;
    const enraged = frame === 1;

    // Skull — rounded arrow pointing +X
    roundedPoly(
      ctx,
      [
        [c + 32, c],
        [c + 8, c - 22],
        [c - 24, c - 16],
        [c - 30, c],
        [c - 24, c + 16],
        [c + 8, c + 22],
      ],
      10,
    );
    fillOutlined(ctx, SCALE_DARK, 6);

    // Jaw line + fangs
    ctx.strokeStyle = css(shade(SCALE_DARK, 0.6));
    ctx.lineWidth = 3.5;
    ctx.beginPath();
    ctx.moveTo(c + 28, c);
    ctx.lineTo(c + 4, c + 4);
    ctx.stroke();
    ctx.fillStyle = css(0xe8e2d0);
    for (const fx of [22, 13]) {
      ctx.beginPath();
      ctx.moveTo(c + fx, c + 4);
      ctx.lineTo(c + fx - 3, c + 12);
      ctx.lineTo(c + fx - 6, c + 4);
      ctx.closePath();
      ctx.fill();
    }

    // Collar ring (matches segment beads)
    ctx.beginPath();
    ctx.arc(c - 26, c, 16, -1.4, 1.4);
    ctx.strokeStyle = css(enraged ? COLORS.dangerRed : RING);
    ctx.lineWidth = 6;
    ctx.stroke();

    // Eye — orange normally, blazing red when enraged
    circle(ctx, c + 6, c - 8, enraged ? 8 : 6.5);
    fillOutlined(ctx, enraged ? COLORS.dangerRed : COLORS.dangerOrange, 3);
    circle(ctx, c + 8, c - 10, 2.2);
    ctx.fillStyle = 'rgba(255,255,255,0.95)';
    ctx.fill();
    if (enraged) {
      circle(ctx, c + 6, c - 8, 12);
      ctx.fillStyle = 'rgba(217, 43, 43, 0.25)';
      ctx.fill();
    }
    void h;
  },
};

/** Body segment bead — purple ring + dark core (bullets pass through). */
export const bossSerpentSegment: ProceduralDef = {
  key: 'boss/serpent/segment',
  width: 48,
  height: 48,
  anchorX: 0.5,
  anchorY: 0.5,
  frames: 1,
  draw(ctx, w, h) {
    const c = w / 2;
    const r = c - 5;
    circle(ctx, c, c, r);
    fillOutlined(ctx, RING, 4.5);
    circle(ctx, c, c, r * 0.58);
    ctx.fillStyle = css(SCALE_DARK);
    ctx.fill();
    // Scale glint
    circle(ctx, c - r * 0.3, c - r * 0.35, r * 0.16);
    ctx.fillStyle = 'rgba(230, 215, 255, 0.6)';
    ctx.fill();
    void h;
  },
};
